import { AdminApiProxiedService, AdminApiService } from '../services';
import type { CampaignImportRequest } from '../services';
import type { CampaignCreate, CampaignUpdate } from '../services';

export type GetCampaignsFilters = {
  search?: string;
  status?: string;
};
export type GetCampaignMonitoringFilters = {
  search?: string;
  campaignId?: string;
  latestContactStateEnum?: string;

  updatedFrom?: string | null;
  updatedTo?: string | null;
  createdFrom?: string | null;
  createdTo?: string | null;
};
export type CampaignCreatePayload = CampaignCreate;
export type CampaignUpdatePayload = CampaignUpdate;

export type TransferCampaignToOrganizationPayload = {
  campaignId: string;
  organizationId: string;
};

export const getCampaigns = (
  filters: GetCampaignsFilters,
  page: ApiPaginationType
) => {
  return AdminApiService.getCampaignsApiAdminCampaignsGet(
    filters.status,
    page.limit,
    page.offset
  );
};

export const getMonitoring = ({
  filters,
  sort,
  page,
}: GetMonitoringPayload) => {
  return AdminApiService.getCampaignMonitoringApiAdminCampaignMonitoringGet(
    filters.campaignId,
    filters.search,
    filters.latestContactStateEnum,
    null,
    sort,
    filters.updatedFrom,
    filters.updatedTo,
    filters.createdFrom,
    filters.createdTo,
    page.limit,
    page.offset
  );
};

export const addCampaign = (payload: CampaignCreatePayload) => {
  return AdminApiService.createCampaignApiAdminCampaignsPost(payload);
};
export const updateCampaign = (id: string, payload: CampaignUpdatePayload) => {
  return AdminApiService.updateCampaignApiAdminCampaignsCampaignIdPatch(
    id,
    payload
  );
};
export const deleteCampaign = (id: string) => {
  return AdminApiService.deleteCampaignApiAdminCampaignsCampaignIdDelete(id);
};

export const getCampaignMonitoring = (
  id: string,
  { filters, customFilters, page, sort }: GetCampaignMonitoringPayload
) => {
  return AdminApiService.getCampaignMonitoringDynamicApiAdminCampaignMonitoringDynamicGet(
    id,
    filters?.search,
    filters?.latestContactStateEnum,
    undefined,
    sort,
    customFilters,
    filters?.updatedFrom,
    filters?.updatedTo,
    filters?.createdFrom,
    filters?.createdTo,
    page?.limit,
    page?.offset
  );
};

export const copyCampaign = async (campaignId: string) => {
  return AdminApiProxiedService.copyCampaignAdminCampaignsCampaignIdCopyPost(
    campaignId
  );
};

export const transferCampaignToOrganization = async ({
  campaignId,
  organizationId,
}: TransferCampaignToOrganizationPayload) => {
  return AdminApiProxiedService.transferCampaignAdminCampaignsCampaignIdTransferPost(
    campaignId,
    { organization_id: organizationId }
  );
};

export const exportCampaign = async (campaignId: string) => {
  return AdminApiProxiedService.exportCampaignAdminCampaignsCampaignIdExportGet(
    campaignId
  );
};

export const importCampaign = async (payload: CampaignImportRequest) => {
  return AdminApiProxiedService.importCampaignAdminCampaignsImportPost(payload);
};

export const KEY_NAME_OPENROUTER = 'openrouter';
export const KEY_NAME_GOOGLE = 'google';

// LLM providers a campaign can route through. The value doubles as the
// campaign.llm_provider token and the secret key_name for that provider.
export const LLM_PROVIDER_OPTIONS = [
  { value: KEY_NAME_OPENROUTER, label: 'OpenRouter' },
  { value: KEY_NAME_GOOGLE, label: 'Google (Gemini)' },
];
export const DEFAULT_LLM_PROVIDER = KEY_NAME_OPENROUTER;

export type GetMonitoringPayload = {
  sort?: string | null;
  page: ApiPaginationType;
  filters: GetCampaignMonitoringFilters;
};
export type GetCampaignMonitoringPayload = {
  sort?: string | null;
  page: ApiPaginationType;
  customFilters?: CustomFilterValue[];
  filters?: GetCampaignMonitoringFilters;
};

export type { CampaignResponse as CampaignType } from '../services';
export type { CampaignExportBundle_Input as CampaignExportBundle } from '../services';
export type { DynamicMonitoringResponse as CampaignMonitoringResponse } from '../services';
export type { CampaignMonitoringResponse as CampaignMonitoringItemType } from '../services';
